import { render, staticRenderFns } from "./DiffStocks.vue?vue&type=template&id=65ad8a12&"
import script from "./DiffStocks.vue?vue&type=script&lang=ts&"
export * from "./DiffStocks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports